import React from 'react';
import { View, Text, StyleSheet, ViewStyle, TextStyle } from 'react-native';
import { Brand, Neutrals } from '@/constants/theme';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'secondary' | 'outline' | 'destructive';
  style?: ViewStyle;
  textStyle?: TextStyle;
}

export function Badge({
  children,
  variant = 'default',
  style,
  textStyle,
}: BadgeProps) {
  return (
    <View style={[styles.badge, styles[variant], style]}>
      <Text style={[styles.text, styles[`text_${variant}`], textStyle]}>
        {children}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  badge: {
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 999,
    alignSelf: 'flex-start',
  },
  default: {
    backgroundColor: Brand.accent,
  },
  secondary: {
    backgroundColor: Brand.primaryLight,
  },
  outline: {
    backgroundColor: 'transparent',
    borderWidth: 1,
    borderColor: Brand.accent,
  },
  destructive: {
    backgroundColor: Brand.destructiveLight,
  },
  text: {
    fontSize: 12,
    fontWeight: '600',
  },
  text_default: {
    color: Neutrals.white,
  },
  text_secondary: {
    color: Brand.primaryDark,
  },
  text_outline: {
    color: Brand.accent,
  },
  text_destructive: {
    color: Neutrals.destructiveDark,
  },
});
